import Spinner from 'src/javascripts/components/utilities/Spinner';

// Check any survey validations
export default function() {

  $('#checkValidations').off().on('click', function(el) {
    let accountUrl = $('body').attr('data-account-url');
    let surveySlug = $('.polling-indicator').attr('data-slug');
    let params = {};

    // Indicate that checking validations
    $('#confirmSubmitHeader').empty().append('Checking validations');
    $('#confirmMessage').addClass('d-none');
    $('#validationErrorMessages').addClass('d-none').empty();
    $('#checkingValidationsMessage').removeClass('d-none');
    $('#approvalMessageModal .modal-footer').addClass('d-none');
    Spinner('#confirmSubmitBody');

    // Check validations
    let url = '/' + accountUrl + '/surveys/' + surveySlug + '/check_validations?' + $.param(params);
    $.ajax({
      type: "POST",
      dataType: "application/json",
      timeout: 3000,
      url: url,
      complete(result) { 
        let responseText = JSON.parse(result.responseText);
        let errorAnswers = responseText.error_answers;
        let alwaysMandatoryAnswers = responseText.always_mandatory_answers;
        let incompleteAnswers = responseText.incomplete_required_answers;
        let allowSubmitOverride = responseText.allow_submit_override;
        let noIssues = (errorAnswers.length === 0) && ((incompleteAnswers === null) || (incompleteAnswers.length === 0));
        if (noIssues) {
          $('#confirmSubmitHeader').empty().append('Confirm submission');
          $('#checkingValidationsMessage').addClass('d-none');
          $('#confirmMessage').removeClass('d-none');
          $('#approvalMessageModal .modal-footer').removeClass('d-none');
          $('#approvalMessageModal .modal-footer').find('#submitQuestionnaireResponse').empty().append('Submit');
          $('#confirmSubmitBody').find('.spinner-container').remove();

        } else {

          let canOverride = (allowSubmitOverride) && (alwaysMandatoryAnswers.length === 0);

          // Always mandatory answers
          let issues = '<div class=\'h6 mb-0\'>';
          if (alwaysMandatoryAnswers.length > 0) {
            $.each(alwaysMandatoryAnswers, function(i,err) {
              issues += '<div class="border-bottom pb-3 mb-3">';
              issues += '<div class="font-italic mb-2"><span class=\'font-weight-bold\'>Question: </span>' + err['name'] + '</div>';
              issues += '<div class="mb-2">' + err['error_message'] + '</div>';
              issues += '<div class="font-weight-bold text-danger">Note that answering this question is mandatory.</div>';
              issues += '</div>';
            })
          }

          // Errors
          issues += '<div class=\'h6 mb-0\'>';
          if (errorAnswers.length > 0) {
            $.each(errorAnswers, function(i,err) {
              issues += '<div class="border-bottom pb-3 mb-3">';
              issues += '<div class="font-italic mb-2"><span class=\'font-weight-bold\'>Question: </span>' + err['name'] + '</div>';
              issues += '<div>' + err['error_message'] + '</div>';
              issues += '</div>';
            })
          }

          // Incomplete required answers
          if ((incompleteAnswers !== null) && (incompleteAnswers.length > 0)) {
            let submissionAttempts = $('#save_response_form').data('submission-attempts');
            issues += '<div class="border-bottom pb-3 mb-3">';
            issues += 'We found ' + incompleteAnswers.length + ' incomplete required questions.';
            if ((allowSubmitOverride) && (errorAnswers.length === 0)) {
              issues += '<br><br>You may over-ride these issues and submit the survey below, but please complete the remaining fields to the extent possible.';
            }
            issues += '</div>';
          }
          if (!canOverride) {
            issues += '<div class="font-italic">Please correct these issues and try again, or reach out to us for support at success@ethosesg.com</div>';
          }

          // Update modal
          $('#confirmSubmitHeader').empty().append('Confirm submission');
          $('#checkingValidationsMessage').addClass('d-none');
          $('#validationErrorMessages').removeClass('d-none').append(issues);
          $('#confirmSubmitBody').find('.spinner-container').remove();

          if (canOverride) {
            $('#confirmMessage').removeClass('d-none');
            $('#approvalMessageModal .modal-footer').removeClass('d-none');
            $('#approvalMessageModal .modal-footer').find('#submitQuestionnaireResponse').empty().append('Override and submit');
          } else {
            $('#confirmMessage').addClass('d-none');
          }

        }
      }
    });

    // On close of modal
    $('#approvalMessageModal').on('hidden.bs.modal', function (e) {
      Turbo.visit(window.location.href);
    })

  })

}
